import { stampAvatars } from "./avatar";
import { stagger } from "./tweens";
import { stampIcons } from "./icons";

// small dom helpers so views only fill in templates from index.html

export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const element = document.getElementById(id);
  if (!element) throw new Error(`missing element #${id}`);
  return element as T;
}

// clone the first element inside a template tag
export function cloneTemplate(templateId: string): HTMLElement {
  const template = byId<HTMLTemplateElement>(templateId);
  const element = template.content.firstElementChild!.cloneNode(true) as HTMLElement;
  stampAvatars(element);
  stampIcons(element);
  return element;
}

// images get a src, everything else gets text
export function fillFields(element: HTMLElement, values: Record<string, string>): HTMLElement {
  for (const [field, value] of Object.entries(values)) {
    const target = element.querySelector<HTMLElement>(`[data-field="${field}"]`) ?? (element.dataset.field === field ? element : null);
    if (!target) continue;
    if (target instanceof HTMLImageElement) target.src = value;
    else target.textContent = value;
  }
  return element;
}

// the toast is a polite live region, urgent ones (errors) interrupt. a changed node makes a repeated message read out again
export function flashToast(text: string, urgent = false): void {
  const toast = byId("toast");
  toast.setAttribute("aria-live", urgent ? "assertive" : "polite");
  toast.textContent = toast.textContent === text ? `${text}\u200b` : text;
  toast.classList.remove("show");
  void toast.offsetWidth;
  toast.classList.add("show");
}

export function renderList<T>(container: HTMLElement, items: T[], build: (item: T) => HTMLElement): void {
  container.replaceChildren(...items.map(build));
  stagger(container);
}

export function renderErrors(container: HTMLElement, errors: string[]): void {
  renderList(container, errors, (text) => fillFields(cloneTemplate("template-error"), { text }));
}
